<ng-container *ngIf="parseData">
  <div
    #tmpl
    p500UITooltip
    [tooltipData]="template?.nativeElement?.innerHTML"
    tooltipPlacement="left"
    [allowTags]="true"
    className="с-pql-field--tooltip"
  >
    <div class="с-pql-field-new--typed-new">
      <ng-container *ngFor="let item of parseData; last as last">
        <div *ngIf="item" class="с-pql-field-new--typed-new">
          <div class="с-pql-field-new__type с-pql-field-new" [ngClass]="item.cssClass">{{ item.key }}</div>
          <div class="с-pql-field-new__name">
            <span>{{ item.value }}</span>
            <span *ngIf="!last">;</span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="!parseData">
  <span class="text-color--light-gray">—</span>
</ng-container>
